import { ResponsiveContainer, ComposedChart, XAxis, YAxis, Bar, Line, LabelList, Tooltip } from "recharts";
import { numberFormatter } from "../../utils";

interface Props {
    chartData: Array<T>
}

interface T {
    quarter: string,
    actualSpend: number,
    projectedSpend: number,
    targetSpend: number,
    lastYearSpend: number,
}

const SpendChart = (props: Props) => {
    const data = props.chartData

    const customTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="custom-tooltip">
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Quarter : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {data.quarter}</label></p>
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Last Year Spend($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.lastYearSpend)}</label></p>
                    {data.actualSpend > 0 && <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Actual Spend($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.actualSpend)}</label></p>}
                    {(data.projectedSpend > 0 || data.targetSpend > 0 ) && <><p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Projected Spend($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.projectedSpend)}</label></p>

                        <p className="label" style={{ padding: "0", margin: "0" }}>
                            <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Target Spend($) : </label>
                            <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                                {numberFormatter(data.targetSpend)}</label></p>
                    </>
                    }
                </div>
            )
        }
    }


    return (
        <ResponsiveContainer width="100%" height="100%" maxHeight={300}>
            <ComposedChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}

            >
                <XAxis
                    dataKey="quarter"
                    stroke="white"
                />
                <YAxis stroke="white" tickFormatter={(value: number) => numberFormatter(value, 0, '$')} />
                <Tooltip contentStyle={{ color: "white", backgroundColor: "rgb(26, 25, 22)" }} cursor={{ strokeDasharray: "3 3" }} content={customTooltip} />
                <Bar dataKey="actualSpend" fill="#98F5F9" barSize={30}>
                    <LabelList dataKey='actualSpend' fill="white" fontSize="12px" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="top"></LabelList>
                </Bar>
                <Bar dataKey="projectedSpend" fill="#EAB308" barSize={30}>
                    <LabelList dataKey='projectedSpend' fill="white" fontSize="12px" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="top"></LabelList>
                </Bar>
                <Bar dataKey="targetSpend" fill="#9ACD32" barSize={30}>
                    <LabelList dataKey='targetSpend' fill="white" fontSize="12px" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="top"></LabelList>
                </Bar>
                <Line type="linear" dataKey="lastYearSpend" stroke="gray" connectNulls={true} strokeWidth={3} />
            </ComposedChart>
        </ResponsiveContainer >
    )
}

export default SpendChart;